import { Flex, styled } from '@grupoboticario/flora-react';

const styles = {
  InfoWrapper: styled(Flex, {
    alignContent: 'initial',
    flexDirection: 'column',
    gap: '$4',

    '@tablet': {
      alignContent: 'center',
      flexDirection: 'row',
    },

    '[data-divider="true"]': {
      display: 'none',

      '@tablet': {
        alignSelf: 'center',
        display: 'block',
      },
    },
  }),
};

export default styles;
